import { AlgoliaArticle, AlmanacFile } from 'types'
import { ResultItem } from './ResultItem'
import { FileIcon } from 'screens/Finder/components/FileIcon/FileIcon'
import Styles from './ResultItem.module.scss'
import { EmptyFile } from './EmptyFile/EmptyFile'

interface Props {
  item: AlgoliaArticle
}

const Preview = ({ item }: Props) => {
  if (item.is_blank)
    return (
      <div className={Styles.emptyFileContainer}>
        <EmptyFile type="doc" />
      </div>
    )

  if (item.preview_url) return <img src={item.preview_url} className={Styles.previewImage} alt="preview" />

  return (
    <div className={Styles.emptyFileContainer}>
      <EmptyFile type="preview" />
    </div>
  )
}

export const ResultItemArticle = ({ item }: Props) => {
  const file = {
    header_emoji: item.header_emoji,
    type: 'article',
    channel_emoji: item.channel_emoji,
  } as any as AlmanacFile

  return (
    <ResultItem
      item={item}
      type="Doc"
      preview={<Preview item={item} />}
      icon={<FileIcon file={file} size="md" color="var(--dark-80)" />}
    />
  )
}
